import { graphql } from "relay-runtime"

export const AppointmentAttachmentFragment = graphql`
  fragment AppointmentAttachmentFragment on AppointmentAttachment @relay(plural: true) {
    id
    url
    thumbnailUrl
    uploadDate
    attachmentType
    fileName
    uploadStatus
    uploadSource
  }
`
